import React from "react";

export type VideoDockView = "chat" | "side";

/** Compact Chat | Video control for panel header or floating over chat. */
export const VideoDockToggle: React.FC<{
  view: VideoDockView;
  onChange: (view: VideoDockView) => void;
  /** Second label (default "Video") */
  sideLabel?: string;
}> = ({ view, onChange, sideLabel = "Video" }) => (
  <div
    className="inline-flex shrink-0 items-center justify-center rounded-xl border border-theme-border bg-theme-surface p-1 shadow-sm"
    role="tablist"
    aria-label="Chat or Video Creator"
  >
    <div className="relative flex min-h-[40px] min-w-[9.5rem] items-stretch rounded-lg bg-theme-background p-1 shadow-inner sm:min-w-[10.5rem]">
      <span
        className="pointer-events-none absolute top-1 bottom-1 rounded-md bg-brand-primary shadow-md transition-[left,width] duration-200 ease-out"
        style={{
          width: "calc(50% - 4px)",
          left: view === "chat" ? "4px" : "calc(50% + 0px)",
        }}
      />
      <button
        type="button"
        role="tab"
        aria-selected={view === "chat"}
        onClick={() => onChange("chat")}
        className={`relative z-10 flex min-h-0 flex-1 items-center justify-center rounded-md px-2 py-1.5 text-[11px] font-semibold uppercase tracking-wide transition-colors duration-150 sm:px-3 sm:text-xs ${
          view === "chat" ? "text-white" : "text-theme-fg-muted hover:text-theme-fg"
        }`}
      >
        Chat
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={view === "side"}
        onClick={() => onChange("side")}
        className={`relative z-10 flex min-h-0 flex-1 items-center justify-center rounded-md px-2 py-1.5 text-[11px] font-semibold uppercase tracking-wide transition-colors duration-150 sm:px-3 sm:text-xs ${
          view === "side" ? "text-white" : "text-theme-fg-muted hover:text-theme-fg"
        }`}
      >
        {sideLabel}
      </button>
    </div>
  </div>
);
